// Real Coding & DSA Profile Data for Vivek Carpenter
// Synced from https://takeuforward.org/profile/vivek_carpenter & LeetCode

export const codingProfile = {
  username: "vivek_carpenter",
  tufProfileUrl: "https://takeuforward.org/profile/vivek_carpenter",
  leetcodeProfileUrl: "https://leetcode.com/u/vicku915/",
  platformsConnected: 2,
  
  // Total statistics
  totalSolved: 82, // 61 (LeetCode) + 21 (TUF)
  activeDays: 19,
  bestStreak: 11,
  contributions12m: 54,
  contests: 0,

  // Platform specific breakdown
  platforms: {
    LeetCode: {
      name: "LeetCode",
      solved: 61,
      total: 4100,
      url: "https://leetcode.com/u/vicku915/",
      categories: [
        { label: "Easy", solved: 35, total: 975, color: "#10b981" },
        { label: "Medium", solved: 26, total: 2138, color: "#f59e0b" },
        { label: "Hard", solved: 0, total: 987, color: "#ef4444" }
      ],
      topTopics: [
        { label: "Array", solved: 36 },
        { label: "Two Pointers", solved: 19 },
        { label: "String", solved: 14 },
        { label: "Hash Table", solved: 9 },
        { label: "Matrix", solved: 6 },
        { label: "Bit Manipulation", solved: 4 },
        { label: "Simulation", solved: 4 },
        { label: "Dynamic Programming", solved: 3 },
        { label: "Greedy", solved: 3 },
        { label: "Sliding Window", solved: 3 }
      ]
    },
    TUF: {
      name: "takeUforward",
      solved: 21,
      total: 1468,
      url: "https://takeuforward.org/profile/vivek_carpenter",
      categories: [
        { label: "Basic", solved: 8, total: 291, color: "#38bdf8" },
        { label: "Core", solved: 13, total: 851, color: "#818cf8" },
        { label: "Pro", solved: 0, total: 313, color: "#c084fc" }
      ],
      topTopics: [
        { label: "Arrays", solved: 8 },
        { label: "Hashing", solved: 2 },
        { label: "Heaps", solved: 2 },
        { label: "Binary Search Trees", solved: 1 },
        { label: "Dynamic Programming", solved: 1 },
        { label: "Trees", solved: 1 },
        { label: "Graphs", solved: 1 },
        { label: "Mathematics", solved: 1 }
      ]
    }
  },

  // Heatmap activity data by date (from TUF API)
  heatmapData: [
    { date: "2025-02-05", count: 4, platform: "LeetCode" },
    { date: "2025-02-11", count: 2, platform: "LeetCode" },
    { date: "2025-02-17", count: 1, platform: "LeetCode" },
    { date: "2025-11-15", count: 1, platform: "TUF" },
    { date: "2025-12-01", count: 3, platform: "LeetCode" },
    { date: "2025-12-03", count: 4, platform: "LeetCode" },
    { date: "2025-12-04", count: 2, platform: "LeetCode" },
    { date: "2025-12-05", count: 1, platform: "LeetCode" },
    { date: "2025-12-10", count: 1, platform: "TUF" },
    { date: "2025-12-11", count: 1, platform: "LeetCode" },
    { date: "2025-12-12", count: 1, platform: "TUF" },
    { date: "2025-12-13", count: 1, platform: "LeetCode" },
    { date: "2025-12-14", count: 2, platform: "TUF" },
    { date: "2025-12-15", count: 2, platform: "LeetCode" },
    { date: "2025-12-16", count: 13, platform: "All" },
    { date: "2025-12-17", count: 1, platform: "TUF" },
    { date: "2025-12-26", count: 1, platform: "LeetCode" },
    { date: "2025-12-27", count: 1, platform: "LeetCode" },
    { date: "2025-12-28", count: 3, platform: "LeetCode" },
    { date: "2025-12-29", count: 2, platform: "TUF" },
    { date: "2026-06-30", count: 1, platform: "LeetCode" },
    { date: "2026-09-25", count: 2, platform: "All" },
    { date: "2026-09-26", count: 2, platform: "LeetCode" },
    { date: "2026-09-27", count: 1, platform: "TUF" },
    { date: "2026-10-01", count: 2, platform: "LeetCode" },
    { date: "2026-10-21", count: 4, platform: "All" },
    { date: "2026-10-22", count: 3, platform: "LeetCode" },
    { date: "2026-10-23", count: 5, platform: "All" },
    { date: "2026-10-24", count: 7, platform: "All" },
    { date: "2026-10-25", count: 2, platform: "LeetCode" },
    { date: "2026-10-26", count: 4, platform: "All" },
    { date: "2026-10-27", count: 4, platform: "All" },
    { date: "2026-10-28", count: 2, platform: "TUF" },
    { date: "2026-10-29", count: 4, platform: "All" },
    { date: "2026-10-30", count: 2, platform: "LeetCode" },
    { date: "2026-10-31", count: 2, platform: "TUF" },
    { date: "2026-11-02", count: 2, platform: "LeetCode" },
    { date: "2026-11-03", count: 3, platform: "All" },
    { date: "2026-11-04", count: 2, platform: "TUF" }
  ]
};
